import { Injectable } from '@angular/core';
import { NgForage } from 'ngforage';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { AbstractOfflineStorageAsyncTimestampService } from 'src/app/services/immo-ip-placer-offline-changes/abstract/abstract-offline-storage-async-timestamp.service';
import { NgForageTimestampService } from 'src/app/services/ng-forage/ng-forage-timestamp.service';
import { ExpiredProjectToTourRemover } from './expired-project-to-tour-remover';
import { ProjectToTour } from './project-to-tour';

@Injectable({
  providedIn: 'root',
})
export class ProjectToTourStorageService extends AbstractOfflineStorageAsyncTimestampService<
  number,
  ProjectToTour,
  ExpiredProjectToTourRemover
> {
  constructor(
    protected ngForage: NgForage,
    protected ngForageTimestampService: NgForageTimestampService
  ) {
    super(
      'project-to-tour-',
      'project-to-tours',
      ngForage,
      ngForageTimestampService
    );
  }

  protected instantiateRemover(): ExpiredProjectToTourRemover {
    return new ExpiredProjectToTourRemover(
      this,
      this.ngForage,
      this.ngForageTimestampService
    );
  }
  public override cleanupOfflineObject(object: ProjectToTour): Promise<void> {
    //Method not implemented.
    return Promise.resolve();
  }
  protected override verifyToStoreObject(projectToTour: ProjectToTour): void {
    if (projectToTour == null) {
      throw new Error('projectToTour must not be null');
    }
    if (projectToTour.id == null) {
      throw new Error('projectToTour.id must not be null');
    }
    if (StringHelper.isEmpty(projectToTour.dateString)) {
      throw new Error('projectToTour.dateString must not be null');
    }
    if (projectToTour.subProjectId == null) {
      throw new Error('projectToTour.subProjectId must not be null');
    }
  }

  public override convertToID(o: any): number {
    const toReturn = GeneralHelper.isNumeric(o) ? o : Number(o);
    if (!GeneralHelper.isNumeric(toReturn)) {
      throw new Error(`${o} could not be converted to number`);
    }
    return toReturn;
  }

  protected override stringifyID(id: number): string {
    return id.toString();
  }
}
